import { webAuth } from "../auth/index";
import store from "../store";
import axios from "axios";

// TODO: Refactor and simplify setup
export default class ReputationProApiClient {
  constructor() {
    this.scope = []; //store.getters.ILMStores.map(m => m.AccountPlatformID);
  }

  setHeadersOptions() {
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new Promise(async (resolve, reject) => {
      this.headers["Authorization"] = store.getters.AuthorizationHeader;
      this.headers["Scope"] = JSON.stringify(this.scope);
      resolve(this.headers);
    });
  }

  getBaseUrl(url) {
    if (url && !url.startsWith("/")) url = "/" + url;
    return process.env.REPUTATIONPRO_API_URL + url;
  }

  ProcessRequest(type, url, payload, scope) {
    let instance = this;
    return new Promise(async (resolve, reject) => {
      instance.setHeadersOptions().then(headers => {
        headers.Scope = JSON.stringify(
          scope && scope.length > 0 ? scope : this.scope
        );
        axios({
          method: type,
          url: instance.getBaseUrl(url),
          data: payload,
          headers: headers
        })
          .then(function(response) {
            return resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/ReputationProApiClient.js